import { render, staticRenderFns } from "./index.vue?vue&type=template&id=074fe9f6&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=074fe9f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074fe9f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('074fe9f6')) {
      api.createRecord('074fe9f6', component.options)
    } else {
      api.reload('074fe9f6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=074fe9f6&scoped=true", function () {
      api.rerender('074fe9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/subject/index.vue"
export default component.exports